import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntitySidebar from 'components/EntitySidebar';
import { CateringSidebar_cateringOption$key } from '__generated__/CateringSidebar_cateringOption.graphql';

type Props = {
  cateringOption: CateringSidebar_cateringOption$key;
};

const CateringSidebar: FC<Props> = props => {
  const cateringOption = useFragment(
    graphql`
      fragment CateringSidebar_cateringOption on CateringOption {
        ...EntitySidebar_entity
      }
    `,
    props.cateringOption
  );

  return <EntitySidebar entity={cateringOption}></EntitySidebar>;
};

export default CateringSidebar;
